var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._b({staticClass:"ellipsis inline-block",staticStyle:{"vertical-align":"bottom"},style:({ maxWidth: _setup.props.width }),attrs:{"title":_vm.text}},'span',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }